 //Generic toaster implementation
import { GPC_SIGNAL } from '../types'

export default (state = false, action) => {
  switch (action.type) {
    case GPC_SIGNAL:
      return action.payload
    default:
      return state;
  }
}